module.exports = __webpack_public_path__ + "img/jcb.529566a.png";